import React, { useState, useEffect } from "react";
import axios from "axios";
import { API, MONTHS } from "../shared/constants";
import { inputStyle, labelStyle, fieldStyle } from "../shared/styles";
import { SimpleModal } from "../shared/SimpleModal";

export function SiteScheduleModal({ siteId, efsms, onClose, onSave }) {
  const [monthlyDay, setMonthlyDay] = useState("");
  const [biAnnualMonth, setBiAnnualMonth] = useState("");
  const [annualMonth, setAnnualMonth] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (efsms.length > 0) {
      const first = efsms[0];
      setMonthlyDay(first.monthly_scheduled_day || "");
      setBiAnnualMonth(first.bi_annual_scheduled_month || "");
      setAnnualMonth(first.annual_scheduled_month || "");
    }
  }, [efsms]);

  const handleSave = async () => {
    setSaving(true);
    setError("");
    try {
      for (const efsm of efsms) {
        await axios.patch(`${API}/site-efsms/${efsm.id}/`, {
          monthly_scheduled_day: monthlyDay ? parseInt(monthlyDay) : null,
          bi_annual_scheduled_month: biAnnualMonth
            ? parseInt(biAnnualMonth)
            : null,
          annual_scheduled_month: annualMonth ? parseInt(annualMonth) : null,
        });
      }
      onSave();
      onClose();
    } catch (e) {
      setError("Something went wrong.");
      setSaving(false);
    }
  };

  return (
    <SimpleModal
      title="Site Schedule Settings"
      onClose={onClose}
      onSave={handleSave}
      saving={saving}
      error={error}
    >
      <p style={{ fontSize: "13px", color: "#666", marginBottom: "20px" }}>
        These settings apply to all EFSMs on this site.
      </p>
      <div style={fieldStyle}>
        <label style={labelStyle}>Monthly — Day of Month</label>
        <input
          style={inputStyle}
          type="number"
          min="1"
          max="31"
          value={monthlyDay}
          onChange={(e) => setMonthlyDay(e.target.value)}
          placeholder="e.g. 15"
        />
      </div>
      <div style={fieldStyle}>
        <label style={labelStyle}>Bi-Annual — Starting Month</label>
        <select
          style={inputStyle}
          value={biAnnualMonth}
          onChange={(e) => setBiAnnualMonth(e.target.value)}
        >
          <option value="">— Select month —</option>
          {MONTHS.map((m, i) => (
            <option key={i} value={i + 1}>
              {m}
            </option>
          ))}
        </select>
      </div>
      <div style={fieldStyle}>
        <label style={labelStyle}>Annual — Month</label>
        <select
          style={inputStyle}
          value={annualMonth}
          onChange={(e) => setAnnualMonth(e.target.value)}
        >
          <option value="">— Select month —</option>
          {MONTHS.map((m, i) => (
            <option key={i} value={i + 1}>
              {m}
            </option>
          ))}
        </select>
      </div>
    </SimpleModal>
  );
}
